import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as Close } from '../../assets/images/svg/close-white.svg';
import themeColors from '../../assets/styles/themeColors';

const CloseStyled = styled(Close)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  stroke: ${({ color }) => color || themeColors.colorTextSecondary};
`;

const CloseWhiteIcon = (props) => <CloseStyled {...props} />;

CloseWhiteIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

CloseWhiteIcon.defaultProps = {
  w: '24px',
  h: '24px',
};

export default CloseWhiteIcon;
